import controller from './controller';
import route from './route';

export { controller, route };


/** WEBPACK FOOTER **
 ** ./app/application/module.ts
 **/